import { cn } from '@/lib/cn';

type Status = 'live' | 'provisioning' | 'degraded' | 'suspended' | 'error' | 'idle';

const colors: Record<Status, string> = {
  live: 'bg-[color:var(--success)]',
  provisioning: 'bg-[color:var(--info)] animate-pulse-dot',
  degraded: 'bg-[color:var(--warn)]',
  suspended: 'bg-[color:var(--warn)]',
  error: 'bg-[color:var(--danger)]',
  idle: 'bg-fg-subtle',
};

const labels: Record<Status, string> = {
  live: 'Live',
  provisioning: 'Provisioning',
  degraded: 'Degraded',
  suspended: 'Suspended',
  error: 'Error',
  idle: 'Idle',
};

export function StatusDot({ status, withLabel = false }: { status: Status; withLabel?: boolean }) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span
        className={cn(
          'inline-block w-1.5 h-1.5 rounded-full',
          colors[status],
        )}
      />
      {withLabel && (
        <span className="text-sm text-fg-muted">{labels[status]}</span>
      )}
    </span>
  );
}
